import styled from 'styled-components';
import Modal from '@iso/components/Feedback/Modal';
import WithDirection from '@iso/lib/helpers/rtl';

const SensorsPage = styled.div`
  width: 100%;
  height: 100%;
  .button-group{
    width: 100%;
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
  }
    
  /* Description See More Button */
  .description-see-more {
    color: #0B2A1B !important;
    font-weight: 500 !important;
    padding: 0 4px !important;
    height: auto !important;
    font-size: 12px !important;
    text-decoration: underline !important;
    
    &:hover {
      color: #0f3d26 !important;
      text-decoration: underline !important;
    }
  }

  /* Device info sections in card title */
  .device-info-section {
    margin-top: 4px;
    
    .device-id {
      font-size: 12px;
      color: rgba(0, 0, 0, 0.45);
    }
    
    .device-description {
      font-size: 12px;
      color: rgba(0, 0, 0, 0.65);
      
      &.no-description {
        font-style: italic;
        color: rgba(0, 0, 0, 0.35);
      }
    }
  }

  /* Description Modal Styling */
  .description-modal {
    .ant-modal-header {
      border-bottom: 1px solid #f0f0f0;
      
      .ant-modal-title {
        color: #0B2A1B;
        font-weight: 600;
      }
    }
    
    .ant-modal-footer {
      border-top: 1px solid #f0f0f0;
      
      .ant-btn-primary {
        background-color: #0B2A1B !important;
        border-color: #0B2A1B !important;
        
        &:hover {
          background-color: #0f3d26 !important;
          border-color: #0f3d26 !important;
        }
      }
    }
  }

  /* Device title section improvements */
  .device-title-section {
    flex: 1;
    
    .device-name-row {
      display: flex;
      align-items: center;
      gap: 8px;
    }
    
    .device-info-row {
      display: flex;
      align-items: center;
      gap: 8px;
      margin-top: 4px;
      
      &.description-row {
        align-items: flex-start;
      }
    }
  }

  /* Edit icon consistency */
  .device-edit-icon,
  .sensor-edit-icon {
    color: #0B2A1B !important;
    cursor: pointer;
    
    &:hover {
      opacity: 0.8;
    }
  }
    .custom-green-button:hover,
.custom-green-button:focus,
.custom-green-button:active {
    border-color: #0B2A1B !important;
    color: #0B2A1B !important;
}

  /* Primary (solid-green) variant — e.g. the "Add Device" button — keeps white
     text on hover/focus. The dark-green text above is only legible on the
     light-background default button ("New View"); on the solid-green primary
     button it would be near-invisible. */
  .custom-green-button.ant-btn-primary:hover,
  .custom-green-button.ant-btn-primary:focus,
  .custom-green-button.ant-btn-primary:active {
    color: #fff !important;
  }

  .btn-success{
    background-color: #0B2A1B !important;
    border-color: #0B2A1B;
    height : 40px ;
    max-width : 155px;
    border-radius : 8px;
    &:hover{
      opacity: 0.8;
    }
  } 
  .search-bar {
    background: rgba(143, 146, 161, 0.05);
    border-radius: 12px;
    border: none;
    height:40px;
    margin-left: 2rem;
    font-weight: 500;
    font-size: 14px;
    line-height: 24px;
    flex-direction: row-reverse;
    max-width: 228px;
  }
  .site-form-item-icon {
    height: 19px;
    width: 19px;
    color: #8F92A1;
    font-size: 19px;
  }
  .site-form-item-cancel {
    height: 15px;
    width: 15px;
    color: #8F92A1;
    font-size: 15px;
  }
  .search-bar .ant-input {
    background: none!important;
    border: none!important;
    color: #8F92A1;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 24px;
  }
  .manage-table .react-collapsible tbody .title {
    font-family: "Inter";
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    color: #101828;
  }
  .manage-property-header {
    padding: 20px 24px;
    display: flex;
    align-items: center;
    margin: auto;
  }

  .manage-table .react-collapsible tbody .name {
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #101828;
}
   
  .ant-table-wrapper {
    min-width: 100%;
  }
  .fAgWDa .ant-table-content{
    overflow-x: unset;
  }
  .fAgWDa{
    overflow-x: unset;
  }
  .dtr-data{
    white-space: break-spaces;
  }
  .delete-button{
    margin-left:8px;
  }
  .dataTables_filter{
    margin-bottom:10px;
  }
  .dataTables_filter .input-sm{
    margin-left:10px;
  }
  .dataTables_filter .input-sm{
    margin-left:10px;
    text-align:center;
    outline-offset: unset;
    border-radius: 8px;
  }
  .react-collapsible-theme .react-collapsible-search input{
    text-align: center;
    border: 0;
    border: 5px #C9C9CE solid;
    border-radius: 6px;
    width: 100%;
    height: 2rem;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.65)
  }
  .search-icon{
    top:5px!important;
    left:15px!important;
    width:20px;
  }

  .clear-icon{
    position: relative; 
    top:5px!important;
    right:2px!important;
  }

  .search-icon svg{
    color: rgba(0, 0, 0, 0.65)
  }

  .action-button.view-history-button, .action-button{
    margin-bottom:5px;
  }

  /* Device Card Styling */
  .ant-card {
    border-radius: 12px !important;
    border: 1px solid #f0f0f0;
    &:hover {
      border-color: #0B2A1B;
      box-shadow: 0 4px 12px rgba(11, 42, 27, 0.15);
    }
  }

  .sensor-value-text {
    color: #0B2A1B !important;
  }

  .sensor-edit-icon {
    color: #0B2A1B !important;
    &:hover {
      color: #0B2A1B !important;
      opacity: 0.8;
    }
  }

  .ant-card .sensor-edit-icon {
    color: #0B2A1B !important;
  }

  .anticon.sensor-edit-icon {
    color: #0B2A1B !important;
  }

  .alarm-button {
    background: transparent !important;
    border: none !important;
    color: #0B2A1B !important;
    box-shadow: none !important;
    &:hover {
      background: rgba(11, 42, 27, 0.1) !important;
      border: none !important;
      color: #0B2A1B !important;
    }
    &:focus {
      background: transparent !important;
      border: none !important;
      color: #0B2A1B !important;
    }
  }

    /* Loading spinner */
  .ant-spin-dot-item {
    background-color: #0B2A1B !important;
  }

  .sensor-card {
    margin-bottom: 16px;
    border: 1px solid #f0f0f0;
    border-radius: 8px;
    padding: 12px;
    transition: all 0.2s;
    background-color: #fafafa;
    
    &.has-data {
      cursor: pointer;
      
      &:hover {
        border-color: #0B2A1B;
      }
    }
    
    &.no-data {
      background-color: #f9f9f9;
      cursor: default;
    }
  }

  .sensor-type-row {
    display: flex;
    align-items: center;
    margin-bottom: 8px;
    padding: 8px 12px;
    background-color: white;
    border-radius: 6px;
    border: 1px solid #f0f0f0;
    transition: all 0.2s ease;

  .sensor-icon {
    margin-right: 8px;
    font-size: 16px;
  }

  .sensor-type-content {
    flex: 1;
  }

  .sensor-type-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .sensor-type-name {
    font-size: 13px;
    font-weight: bold;
    text-transform: capitalize;
  }

  .sensor-controls {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .last-updated {
    font-size: 11px;
    color: rgba(0, 0, 0, 0.45);
  }

  .click-hint {
    margin-top: 8px;
    text-align: center;
    font-size: 11px;
    font-style: italic;
    color: rgba(0, 0, 0, 0.45);
  }

  .no-data-message {
    text-align: center;
    padding: 20px;
    color: #999;
    font-style: italic;
    font-size: 12px;
  }

  .no-sensors-message {
    text-align: center;
    padding: 40px 20px;
    color: #666;
    font-style: italic;
    background-color: #fafafa;
    border-radius: 4px;
    border: 1px dashed #d9d9d9;
  }

  .ant-input-affix-wrapper:not(.ant-input-affix-wrapper-disabled):hover {
    color: black;
    border-color: white;
    border-right-width: 1px;
    z-index: 1;
}

  /* Replace your existing custom-search styles with these more specific ones */
  .custom-search .ant-input-search-button {
      border-radius: 0 20px 20px 0 !important;
      background-color: #0B2A1B !important;
      border-color: #0B2A1B !important;
  }

  .custom-search .ant-input-search-button:hover,
  .custom-search .ant-input-search-button:active {
      background-color: #0f3d26 !important;
      border-color: #0f3d26 !important;
  }

  .custom-search .ant-input-affix-wrapper {
      border-radius: 20px !important;
      border-color: #d9d9d9 !important;
      transition: all 0.3s ease !important;
  }

  .custom-search .ant-input-affix-wrapper:hover {
      border-color: #0B2A1B !important;
      box-shadow: 0 0 0 2px rgba(11, 42, 27, 0.1) !important;
  }

  .custom-search .ant-input-affix-wrapper:focus,
  .custom-search .ant-input-affix-wrapper:focus-within,
  .custom-search .ant-input-affix-wrapper.ant-input-affix-wrapper-focused,
  .custom-search .ant-input-affix-wrapper-focused {
      border-color: #0B2A1B !important;
      box-shadow: 0 0 0 2px rgba(11, 42, 27, 0.2) !important;
      outline: none !important;
  }

  .custom-search .ant-input {
      border: none !important;
      box-shadow: none !important;
  }

  .custom-search .ant-input:hover,
  .custom-search .ant-input:focus,
  .custom-search .ant-input:active {
      border: none !important;
      box-shadow: none !important;
      outline: none !important;
      border-color: #0B2A1B !important;
  }

  /* Remove or update this conflicting selector */
  /* .ant-input-search .ant-input:hover, .ant-input-search .ant-input:focus {
      border-color: #0B2A1B !important;
  } */

  /* Replace with this more specific version */
  .custom-search.ant-input-search .ant-input:hover, 
  .custom-search.ant-input-search .ant-input:focus {
      border-color: #0B2A1B !important;
  }

  /* Additional catch-all for any remaining states */
  .custom-search *:focus {
      border-color: #0B2A1B !important;
      box-shadow: 0 0 0 2px rgba(11, 42, 27, 0.2) !important;
      outline: none !important;
  }
  }
  .ant-spin-dot-item{
  }

  @media only screen and (max-width : 425px)
  {
    .search-bar{
      margin-left: 1rem;
    }
   .manage-property-header{
    padding : 20px 18px;
   }
  }
  @media only screen and (max-width : 375px)
  {
    .manage-property-header{
      flex-wrap : wrap;
      padding : 20px 18px;
     }
     .search-bar{
      margin-bottom : 10px;
      max-width :100%;
      width : 100%;
      margin-left: 0rem;
    }
    .manage-property-header .button-group .btn-success{
      max-width : 100%;
      min-width : 100%;
    }
    .ant-card-body{
      padding : 24px 24px 0px 24px !important;
    }

`;

export default WithDirection(SensorsPage);